import { render } from "./LuisQuote.vue?vue&type=template&id=19122803"
import script from "./LuisQuote.vue?vue&type=script&lang=js"
export * from "./LuisQuote.vue?vue&type=script&lang=js"

import exportComponent from "/Users/michelnussbaum/Documents/WS/luisvue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__